import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['Carlos', 'María', 'Juan', 'Florencia', 'Lucas', 'Ana', 'Diego', 'Sofía'];
const CITIES = ['Córdoba', 'CABA', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseData, setPurchaseData] = useState({
    name: '',
    city: '',
    time: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1; // 1 to 15 mins ago
      setPurchaseData({
        name: randomName,
        city: randomCity,
        time: `${randomTime} min`
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // hide after 5 seconds
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 10000);
    // Recurring interval
    const interval = setInterval(() => {
      showPopup();
    }, 25000); // every 25 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-11">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 30
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-50" data-id="element-12">
          <div className="bg-white rounded-lg shadow-xl border border-gray-100 p-3 flex items-center gap-3 max-w-xs" data-id="element-13">
            <div className="bg-green-100 p-2 rounded-full" data-id="element-14">
              <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-15" />
            </div>
            <div data-id="element-16">
              <p className="text-sm text-gray-800" data-id="element-17">
                <span className="font-bold" data-id="element-18">{purchaseData.name}</span> de{' '}
                {purchaseData.city}
              </p>
              <p className="text-xs text-gray-500" data-id="element-19">
                Compró el KIT Contador Ágil hace {purchaseData.time}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}